/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSignaturePlacesList } from '../fn/signature-place-controller/get-signature-places-list';
import { GetSignaturePlacesList$Params } from '../fn/signature-place-controller/get-signature-places-list';
import { SignaturePlace } from '../models/signature-place';

@Injectable({ providedIn: 'root' })
export class SignaturePlaceControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `signaturePlaceControllerGetSignaturePlacesList()` */
  static readonly SignaturePlaceControllerGetSignaturePlacesListPath = '/signature-places';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSignaturePlacesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSignaturePlacesList$Response(params?: GetSignaturePlacesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SignaturePlace>>> {
    return getSignaturePlacesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSignaturePlacesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSignaturePlacesList(params?: GetSignaturePlacesList$Params, context?: HttpContext): Observable<Array<SignaturePlace>> {
    return this.getSignaturePlacesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SignaturePlace>>): Array<SignaturePlace> => r.body)
    );
  }

}
